import restAPI from "@/http-common";
import { averageWastePerGuestRequest, trashEventsRequest } from "./CancellableRequest";
import AdApi from "./Api";
import session from "./session";
import store from "@/store";

class MenuItemsApi {
	getTrashEvents(params) {
		trashEventsRequest.cancel();

		return restAPI({
			method: "get",
			url: "top-wasted-items?",
			params: {
				...AdApi.getQueryParams(),
				...params,
			},
			headers: session.getIdToken() ? { Authorization: session.getIdToken() } : {},
			cancelToken: trashEventsRequest.generateCancelToken(),
		});
	}

	getAverageWastePerGuestPerDay() {
		const activePeriod =
			store.getters["filters/activePeriod"] === "day" ? "week" : store.getters["filters/activePeriod"];

		averageWastePerGuestRequest.cancel();

		const params = {
			...AdApi.getQueryParams(false, {
				activePeriodOverride: activePeriod,
				activeCompareToOverride: `average_${activePeriod}`,
			}),
			average: "week",
		};

		return restAPI({
			method: "get",
			url: "average-waste-per-guest-per-service-time?",
			params: params,
			headers: session.getIdToken() ? { Authorization: session.getIdToken() } : {},
			cancelToken: averageWastePerGuestRequest.generateCancelToken(),
		});
	}
}

export const MenuItemsService = new MenuItemsApi();
